import { render, staticRenderFns } from "./GlobalNetwork.vue?vue&type=template&id=1a8e12d1&scoped=true"
import script from "./GlobalNetwork.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalNetwork.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GlobalNetwork.vue?vue&type=style&index=0&id=1a8e12d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e12d1",
  null
  
)

export default component.exports